import React, { useState } from "react";
import { Box, Stack, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Header from "../../partials/header";
import LeftSidebar from "../../partials/leftSidebar";
import PlatformTab from './PlatformTab';

const PlatformMain = () => {
    const breadCrumb = [
        {
            label: "Admin",
            path: "/admin",
        },
        {
            label: "Platform Management",
            path: "/admin/platform",
        },
    ];
    const [activeTab, setActiveTab] = useState<"users" | "roles" | "platform">("platform");
    
    return (
        <Box sx={{ display: "flex"}}>
            <Header title="" breadCrumb={breadCrumb} />
            <LeftSidebar />
             {activeTab === "platform" && <PlatformTab />}
        </Box>


    );
};

export default PlatformMain;